import React from 'react';
import './FloatingButton.css'; // Import the CSS file
import { MailOutlined } from '@ant-design/icons';

const FloatingButton = ({ onClick }) => {
  return (
    <button className="floating-button" onClick={onClick}>
      <a href="mailto:sales@shipmnts.com" target="_blank" rel="noreferrer">
        <MailOutlined />
      </a>
    </button>
  );
};

export default FloatingButton;
